import(/* webpackMode: "eager" */ "/vercel/path0/app/activites/page.tsx");
